import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-center h-full px-6 text-center tablet:px-8"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_splide_slide = _resolveComponent("splide-slide")
  const _component_splide = _resolveComponent("splide")

  return ($props.data.length > 0 && $data.announcementBarData.length > 0)
    ? (_openBlock(), _createBlock(_component_splide, {
        key: 0,
        options: {
      type: $props.autoSlide ? 'loop' : 'slide',
      pagination: false,
      autoHeight: true,
      drag: false,
      perPage: 1,
      perMove: 1,
      arrows: false,
      autoplay: $props.autoSlide,
      interval: $props.autoSlide && $props.slideInterval,
      speed: '600',
      easing: 'ease',
      destroy: $data.announcementBarData.length > 1 ? false : 'completely',
    }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.announcementBarData, (bar) => {
            return (_openBlock(), _createBlock(_component_splide_slide, {
              key: bar.text,
              class: "flex-center min-h-[2rem] w-full items-center bg-secondary py-1.5 px-2 text-sm mobile:px-4 tablet:px-15 tablet:text-md"
            }, {
              default: _withCtx(() => [
                (bar.text)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (bar.url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: bar.url
                          }, _toDisplayString(bar.text), 9, _hoisted_2))
                        : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(bar.text), 1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["options"]))
    : _createCommentVNode("", true)
}